


















import Vue, { PropType } from 'vue';

// Types and services
import { ImportModes } from '../modals/ProfileImportModal.vue';

// Components
import Button from '~/components/builders/Base/Button.vue';

// Assets
import LinkedInLogo from '~/assets/img/LlnkedinSquare.svg';
import LinkedInReverseLogo from '~/assets/img/LlnkedinSquareReverse.svg';

// Types
type Variant = 'outline-primary' | 'text-secondary';

export default Vue.extend({
    name: 'LinkedinImportButton',
    components: { Button },
    props: {
        variant: {
            type: String as PropType<Variant>,
            default: 'outline-primary' as Variant,
        },
        tiny: Boolean,
        logo: {
            type: Boolean,
            default: true,
        },
        importMode: {
            type: String as PropType<ImportModes>,
            default: ImportModes.EnterId,
        },
    },
    data() {
        return {
            LinkedInLogo,
            LinkedInReverseLogo,
        };
    },
    methods: {
        handleClick() {
            if (this.$listeners['openProfileImport']) {
                this.$emit('openProfileImport');
            } else if (this.$listeners['click']) {
                this.$emit('click');
            } else {
                this.openProfileImportDialog(this.importMode);
            }
        },
        openProfileImportDialog(state: ImportModes) {
            const event = new CustomEvent('profileimport:modal:show', {
                detail: state,
            });
            window.dispatchEvent(event);
        },
    },
});
